
const InlineErrormsg = (props) => (
  <span className='invalid-feedback'>
    <strong>{props.message}</strong>
  </span>
)

export default InlineErrormsg